import { defineStore } from 'pinia';
import { api, nurse, customer } from '@/services';
import { capitalize } from '@/services/CommonService';
import { useCookie } from '@/utils/composables/useCookie';
import router from '@/router';
const vtoken = import.meta.env.VITE_TOKEN;
const vuser = import.meta.env.VITE_USER;

const userRoles = {
	nurse: 'nurse',
	customer: 'customer',
};
const channelVar = 'channel_token';

export const useAuthStore = defineStore({
	id: 'auth',
	state: () => ({
		mode: localStorage.getItem('mode') || userRoles.customer, // nurse | customer
		token: useCookie(vtoken).value || null,
		tokenRegister: useCookie(vtoken).value,
		user: useCookie(vuser).value || {},
		lang: localStorage.getItem('lang') || 'vi',
		error: {},
		tempCustomerPhone: '',
		tempCustomerEmail: '',
		tempCustomerOtp: '',
    tempCustomerHashedOtp: '',
		haveNewMessages: false,
		isRequestListUpdated: false,
		channelToken: localStorage.getItem(channelVar) || '',
		servicePath: ''
	}),
	getters: {
		idRegisterNurse: state => state.user.id,
		getAvatar: (state) => {
			const user = state.user || {};

			if (state.mode !== userRoles.nurse) {
				return user.media?.path;
			}

			if (!user.nurseMedia) return '';
			const nurseMedia = user.nurseMedia || [];
			const avatar = nurseMedia.find((x) => x.type === 'avatar');
			return avatar ? avatar.path : null;
		},
		getTempCustomerPhone: (state) => {
			return state.tempCustomerPhone;
		},
		// User sign in/sign up by their email(temporarily)
		getTempCustomerEmail: (state) => {
			return state.tempCustomerEmail;
		},
		getTempCustomerOtp: (state) => {
			return state.tempCustomerOtp;
		},
		getTempCustomerHashedOtp: (state) => {
			return state.tempCustomerHashedOtp;
		},
		isNurseActive: (state) => state.mode === userRoles.nurse,
		isCustomerLoggedIn: (state) => !!state.token && state.mode === userRoles.customer,
		notificationStatus (state) {
			return state.haveNewMessages
		},
		getHomeRoute(state) {
			if (state.token) {
				return capitalize(state.mode) + 'Home'
			} else {
				return 'CustomerHome'
			}
		}
	},
	actions: {
		setUser(data) {
			// update pinia state token
			this.token = data.token;
			useCookie(vtoken).value = this.token; // local storage
			delete data.password;

			// update pinia state user
			this.user = data;
      useCookie(vuser).value = this.user
		},
		setMode(mode) {
			this.mode = mode;
			localStorage.setItem('mode', mode); // local storage
		},
		setCustomerMode() {
			this.mode = userRoles.customer;
			localStorage.setItem('mode', userRoles.customer);
		},
		async reloadUser() {
			if (this.token) {
				const res = await api.get(`/${this.mode}/me`);
				const data = res?.data ?? {};
				if (!data.error) {
					this.setUser(data);
				}
			}
		},
		async login(body, mode = 'nurse') {
			try {
				const linkLogin = mode === 'nurse' ? nurse.login : customer.login;
				const res = await api.post(linkLogin, body);
				const data = res.data ?? {};
				if (data.error) {
					this.error = data.data;
					return;
				}

				// update pinia state mode
				this.setMode(mode);
				this.setUser(data);

				// redirect to previous url or default to home page
				if (mode === 'nurse') router.push({ name: 'NurseHome' });
				else router.push('/');
			} catch (error) {
				// alert error
				console.log(error);
			}
		},
		logout(path = '/cong-tac-vien') {
			path = !path ? '/cong-tac-vien' : path;
			this.token = null;
      useCookie(vtoken).value = null
			this.user = {};
			this.haveNewMessages = false;
			this.mode = userRoles.customer
			localStorage.removeItem(channelVar);
      useCookie(vuser).value = null
			localStorage.removeItem('mode');
			router.push(path);
		},
		cleanToken() {
			this.token = null;
      useCookie(vtoken).value = null
			this.user = {};
			this.haveNewMessages = false;
			this.mode = userRoles.customer
			localStorage.removeItem(channelVar);
			useCookie(vuser).value = null
			localStorage.removeItem('mode');
		},
		setTempCustomerPhone(phone = '') {
			this.tempCustomerPhone = phone;
		},
		setTempCustomerHashedOtp(hashedOtp = '') {
			this.tempCustomerHashedOtp = hashedOtp;
		},
		setTempCustomerEmail(email = '') {
			this.tempCustomerEmail = email;
		},
		setTempCustomerOtp(otp = '') {
			this.tempCustomerOtp = otp;
		},
		// Set status of notification
		setNotifStatus (haveNewMessages = false) {
      this.haveNewMessages = haveNewMessages;
    },
		setSignalOfRequests (isRequestListUpdated = false) {
      this.isRequestListUpdated = isRequestListUpdated;
    },
		setChannelToken (token = '') {
			this.channelToken = token;
			localStorage.setItem(channelVar, token);
		},
		setServicePath (path = '') {
			this.servicePath = path
		}
	},
});
